import { isMobile } from 'react-device-detect'
import styles from './rgbCircle.module.scss'
import cn from 'classnames'

/**
 * RGB Circle Hotspot with proper ARIA attributes
 *
 * @param {string} classNames - Additional CSS classes
 * @param {boolean} $isActive - Whether this hotspot is currently active/selected
 * @param {Function} onClick - Click handler
 * @param {string} ariaLabel - Accessible label for screen readers
 * @param {object} props - Additional props passed to the div
 */
const RgbCircle = ({ classNames, $isActive, onClick, ariaLabel, ...props }) => {
  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      if (onClick) {
        onClick(e)
      }
    }
  }

  return (
    <div
      className={cn(styles.hotspot, {
        [styles.hotspotMobile]: isMobile,
        [styles.hotspotActive]: $isActive
      })}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={$isActive}
      aria-label={ariaLabel || 'Hotspot'}
      {...props}
    />
  )
}

export default RgbCircle
